import React from 'react';
import { Link } from 'react-router-dom';

import MilanLogo from '../../components/icons/MilanLogo';

/**
 * Renders Milan's single persistent brand mark and top fade, plus an interactive "Try Beta" header action.
 *
 * @param {object} props - Brand presentation state.
 * @param {boolean} props.compact - Selects the compact fixed-header state when true.
 * @param {boolean} [props.onDark=false] - Applies the inverse treatment on dark chapters.
 * @returns {React.ReactElement} The decorative fade, logo mark, and header action.
 * @sideEffects Has no external side effects beyond React rendering.
 */
export default function BrandMarkTransition({ compact, onDark = false }) {
  const stateClass = compact ? 'brand-mark--compact' : 'brand-mark--hero';
  const inverseClass = onDark ? ' brand-mark--inverse' : '';

  return (
    <>
      <div
        className={'brand-top-fade' + (compact ? ' brand-top-fade--visible' : '')}
        aria-hidden="true"
      />
      <div
        className={'brand-mark ' + stateClass + inverseClass}
        role="img"
        aria-label="Milan"
      >
        <MilanLogo className="brand-mark__logo" aria-hidden="true" />
      </div>
      <Link
        to="/download"
        className={
          'brand-try-beta' +
          (compact ? ' brand-try-beta--visible' : '') +
          (onDark ? ' brand-try-beta--inverse' : '')
        }
      >
        Try Beta
      </Link>
    </>
  );
}

